import { useQuery, type UseQueryOptions } from 'react-query'

import {
  type CompanyFinanceSettings,
  fetchIsBudgetOverageEnabled,
} from '@webapp/api/SettingsAPI'
import { type IApiV3Error, type IApiV3Response } from '@webapp/services/api'

export const fetchIsBudgetOverageEnabledRequest = (): Promise<
  IApiV3Response<CompanyFinanceSettings>
> => fetchIsBudgetOverageEnabled()

export const useFetchIsBudgetOverageEnabled = (
  config?: Omit<
    UseQueryOptions<IApiV3Response<CompanyFinanceSettings>, IApiV3Error>,
    'queryFn' | 'queryKey'
  >
) =>
  useQuery(
    'isBudgetOverageEnabled',
    () => fetchIsBudgetOverageEnabledRequest(),
    config
  )
